export class BoardApprovalAddNotesParameterDto {
    note: string;
    isOpen: boolean;
    communityId: number;
    processId: string;
    clearCache = false;
    action: string;
}
